import axios from './axiosConfig';
import { AxiosPromise } from 'axios';
import { IFeedback } from '../models/feedback.model';

export const getFeedback = (scheduleId: number): AxiosPromise<IFeedback> => {
  return axios.get(`/api/schedule/${scheduleId}/feedback`);
};
